import { render } from "./BlogValueCount.vue?vue&type=template&id=587703c2"
import script from "./BlogValueCount.vue?vue&type=script&lang=js"
export * from "./BlogValueCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__